export default __webpack_public_path__ + "static/media/origin.9aac440f.svg";